import AdminLayout from '../../components/feature/AdminLayout';
import OrderPlansTable from './components/OrderPlansTable';

export default function OrderPlansPage() {
  return (
    <AdminLayout>
      <OrderPlansTable />
    </AdminLayout>
  );
}
